export type WholesaleConfig = { minQuantity: number; tierPrice: number };

export function getEffectiveUnitPrice(
  retailUnit: number,
  quantity: number,
  wholesale: WholesaleConfig | null | undefined
): number {
  if (!wholesale || quantity < wholesale.minQuantity) return retailUnit;
  return wholesale.tierPrice / wholesale.minQuantity;
}

export function getCartLineSubtotal(item: {
  price: number;
  quantity: number;
  wholesale?: WholesaleConfig | null;
}): number {
  const unit = getEffectiveUnitPrice(item.price, item.quantity, item.wholesale);
  return unit * item.quantity;
}

type ProductWholesaleSource = {
  wholesaleEnabled?: boolean;
  wholesaleMinQuantity?: number;
  wholesaleTierPrice?: number;
  variants?: Array<{
    sku?: string;
    wholesaleMinQuantity?: number;
    wholesaleTierPrice?: number;
  }>;
};

export function wholesaleConfigForCart(
  product: ProductWholesaleSource,
  variantSku?: string
): WholesaleConfig | null {
  if (!product.wholesaleEnabled) return null;
  const v = variantSku
    ? product.variants?.find((x) => x.sku === variantSku)
    : undefined;
  if (
    v &&
    typeof v.wholesaleMinQuantity === 'number' &&
    v.wholesaleMinQuantity >= 2 &&
    typeof v.wholesaleTierPrice === 'number' &&
    v.wholesaleTierPrice > 0
  ) {
    return { minQuantity: v.wholesaleMinQuantity, tierPrice: v.wholesaleTierPrice };
  }
  if (
    typeof product.wholesaleMinQuantity === 'number' &&
    product.wholesaleMinQuantity >= 2 &&
    typeof product.wholesaleTierPrice === 'number' &&
    product.wholesaleTierPrice > 0
  ) {
    return {
      minQuantity: product.wholesaleMinQuantity,
      tierPrice: product.wholesaleTierPrice,
    };
  }
  return null;
}
